import React, { useContext, useEffect, useState, useCallback } from "react";
import { Embedded, Page, ItemsList, Icon, Spinner, Button } from "components";
import UserContext from "context/UserContext";
import PreviewContext from "context/PreviewContext";
import useReactRouter from "use-react-router";
import { useMutation } from "@apollo/react-hooks";
import { faPlus, faUsdSquare } from "@fortawesome/fontawesome-pro-solid";
import _ from "lodash";
import { Loading, Toast, Modal } from "@shopify/app-bridge-react";
import useShop from "hooks/useShop";
import {
  SWITCH_CAMPAIGN_STATUS,
  REMOVE_CAMPAIGN_MUTATION
} from "lib/mutations";
import { LIST_SHOP_CAMPAIGNS } from "Queries";
import { BOX_CHECK_ICON, CAMPAIGN_TARGETS, BREAK_POINTS } from "lib/globals";
import classNames from "lib/classNames";
import ShopContext from "context/ShopContext";
import { API } from "aws-amplify";
import { Popover } from "react-tiny-popover";
import { useQuery } from "@apollo/react-hooks";

const List = () => {
  const limitCampaigns = 20;
  const [, updateState] = useState();
  const [analytics, setAnalytics] = useState([]);
  const [popovers, setPopOvers] = useState({});
  const showPopOver = (id) =>
    setPopOvers(Object.assign({}, popovers, { [id]: true }));
  const hidePopOver = (id) =>
    setPopOvers(Object.assign({}, popovers, { [id]: false }));
  const forceUpdate = useCallback(() => updateState({}), []);
  const user = useContext(UserContext);
  const { collapsed, previewCampaign, preview_active_campaign } =
    useContext(PreviewContext);
  const shopContext = useContext(ShopContext);
  const {
    state: {
      settings: { multiCurrencyMode },
      money_format
    }
  } = shopContext;
  const killDraftBreakPoint = BREAK_POINTS["kill_draft"](shopContext);

  const { history, location } = useReactRouter();
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const formatWithDelimiters = (
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) => {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  };
  const formatMoney = (n) => {
    n *= 100;
    return money_format
      .replace(/{{\s*?amount\s*?}}/g, formatWithDelimiters(n, 2))
      .replace(/{{\s*?amount_no_decimals\s*?}}/g, formatWithDelimiters(n, 0))
      .replace(
        /{{\s*?amount_with_comma_separator\s*?}}/g,
        formatWithDelimiters(n, 2, ".", ",")
      )
      .replace(
        /{{\s*?amount_no_decimals_with_comma_separator\s*?}}/g,
        formatWithDelimiters(n, 0, ".", ",")
      )
      .replace(
        /{{\s*?amount_with_apostrophe_separator\s*? }}/g,
        formatWithDelimiters(n, 2, "'", ".")
      );
  };
  const numberFormat = new Intl.NumberFormat("en-US", {
    maximumSignificantDigits: 3
  }).format;
  let {
    data,
    loading: queryLoading,
    error: queryError,
    fetchMore
  } = useQuery(LIST_SHOP_CAMPAIGNS, {
    variables: {
      userId: user.attributes.sub
    }
  });
  // if (data && data.campaigns.list.length && !preview_active_campaign) {
  // 	previewCampaign(data.campaigns.list[0], false);
  // }
  let [
    SetCampaignActiveMutation,
    {
      loading: SetCampaignActiveMutation_loading,
      error: SetCampaignActiveMutation_error,
      data: SetCampaignActiveMutation_data
    }
  ] = useMutation(SWITCH_CAMPAIGN_STATUS, {
    refetchQueries: [
      {
        query: LIST_SHOP_CAMPAIGNS,
        variables: {
          userId: user.attributes.sub
        }
      }
    ]
  });
  let [
    RemoveCampaignMutation,
    {
      loading: RemoveCampaignMutation_loading,
      error: RemoveCampaignMutation_error,
      data: RemoveCampaignMutation_data
    }
  ] = useMutation(REMOVE_CAMPAIGN_MUTATION, {
    refetchQueries: [
      {
        query: LIST_SHOP_CAMPAIGNS,
        variables: {
          userId: user.attributes.sub
        }
      }
    ]
  });
  const setCampaignActive = (id, active) => {
    SetCampaignActiveMutation({
      variables: { id, input: { active } }
    });
  };
  const confirmDelete = (id) => {
    setShowConfirmDelete(id); //store campaign id
  };

  const isBeingPreviewed = (campaign) =>
    campaign == preview_active_campaign && !collapsed;

  const edit = (id) => history.push(`/campaigns/${id}` + location.search);
  const duplicate = (id) => {
    if (data.campaigns.list.length > limitCampaigns) {
      console.log("limited");
    } else {
      history.push(`/campaigns/create/${id}` + location.search);
    }
  };

  useEffect(() => {
    if (SetCampaignActiveMutation_data) {
      let index = _.findIndex(data.campaigns.list, {
        id: SetCampaignActiveMutation_data.updateCampaign.id
      });
      data.campaigns.list[index] =
        SetCampaignActiveMutation_data.updateCampaign;
      forceUpdate();
    }
  }, [SetCampaignActiveMutation_data]);

  useEffect(() => {
    if (RemoveCampaignMutation_data) {
      data.campaigns.list = data.campaigns.list.filter(
        ({ id }) => id != RemoveCampaignMutation_data.removeCampaign.id
      );
      forceUpdate();
    }
  }, [RemoveCampaignMutation_data]);

  const fetchStatistics = async (campaigns) => {
    const campaigns_list = campaigns
      .filter(({ settings }) => settings?.type !== "one_check_up_sell")
      .map(({ id }) => id);
    const one_tick_campaigns = campaigns
      .filter(({ settings }) => settings?.type === "one_check_up_sell")
      .map(({ id, settings }) => [
        id,
        settings?.one_check_up_sell?.product?.id,
        settings?.one_check_up_sell?.product?.variants[0].price
      ]);
    const data = await API.post("API_GATEWAY", "/analytics/campaigns", {
      body: {
        campaigns: campaigns_list,
        one_tick_campaigns
      }
    });
    setAnalytics(data);
  };
  const callLoadMore = () => {
    fetchMore({
      variables: {
        userId: user.attributes.sub,
        nextToken: data?.campaigns?.nextToken
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          campaigns: Object.assign({}, fetchMoreResult.campaigns, {
            list: [...prev.campaigns.list, ...fetchMoreResult.campaigns.list]
          })
        };
      }
    });
  };
  useEffect(() => {
    // console.log("data", data);
    if (data) {
      //   data.campaigns.list = data.campaigns.list
      //     .sort((a, b) => {
      //       return b.createdAt - a.createdAt;
      //     })
      //     .slice(0);
      //   if (!analytics.length) {

      // }
      fetchStatistics(data.campaigns.list);
      // forceUpdate();
    }
  }, [data]);

  if (
    queryError ||
    SetCampaignActiveMutation_error ||
    RemoveCampaignMutation_error
  ) {
    throw new Error(
      JSON.stringify({
        queryError,
        SetCampaignActiveMutation_error,
        RemoveCampaignMutation_error
      })
    );
  }

  return (
    <>
      {(SetCampaignActiveMutation_loading ||
        RemoveCampaignMutation_loading) && <Loading />}
      {SetCampaignActiveMutation_data && (
        <Toast
          content={`Campaign has been updated`}
          duration={3000}
          onDismiss={() => {
            SetCampaignActiveMutation_data = null;
          }}
        />
      )}
      {RemoveCampaignMutation_data && (
        <Toast
          content={`Campaign has been removed`}
          duration={3000}
          onDismiss={() => {
            RemoveCampaignMutation_data = null;
          }}
        />
      )}
      <Page
        header={{
          title: "Campaign Dashboard",
          actions: [
            {
              type: "link-info",
              text: "New Campaign",
              icon: faPlus,
              onClick: (e) => {
                if (data.campaigns.list.length > limitCampaigns) {
                  console.log("limited");
                } else {
                  history.push("campaigns/create" + location.search);
                }
              }
            }
          ]
        }}
        loading={{
          text: "Fetching campaigns",
          status: queryLoading
        }}
      >
        <ItemsList
          header={[
            {
              title: "Active",
              onChange: ({ id }, active) => setCampaignActive(id, active)
            },
            {
              title: "Campaign",
              value: (campaign) => {
                const {
                  name,
                  settings: { type, add_to_unlock, one_check_up_sell },
                  target
                } = campaign;
                const isGlobalBundles =
                  type === "bundles" && target.type === "all_products";
                const isMonsterFreeShippingAddToUnlock =
                  type === "add_to_unlock" &&
                  add_to_unlock?.goals?.length === 1 &&
                  add_to_unlock?.goals[0].reward_type === "free_shipping" &&
                  add_to_unlock?.goals[0].free_shipping.manual === false;
                const isVirtualOneCheck =
                  type === "one_check_up_sell" &&
                  one_check_up_sell?.product_type === "hidden";

                const isNotDelivering =
                  multiCurrencyMode && (isGlobalBundles || isVirtualOneCheck);

                return (
                  <div className={classNames("px-2")}>
                    <h2
                      className={classNames("font-bold text-gray-700 text-sm")}
                    >
                      {campaign.name}
                    </h2>
                    {isNotDelivering && (
                      <div className={classNames("mt-1 text-gray text-xs")}>
                        <h4
                          className={classNames(
                            "font-semibold flex items-center text-orange-500 leading-none"
                          )}
                        >
                          <Icon
                            icon="exclamation-square"
                            className="mr-1"
                            size="lg"
                          />
                          Not delivering
                        </h4>
                        <p className={classNames("text-gray-600")}>
                          due to 16th May checkout upgrade. Please edit this
                          campaign to fix this.
                          <a
                            className={classNames(
                              "ml-2 underline cursor-pointer font-semibold"
                            )}
                            href="https://monsterapps.crisp.help/en/article/draft-checkout-removed-16th-may-update-de3y6j/"
                            target="_blank"
                          >
                            Learn More
                          </a>
                        </p>
                      </div>
                    )}
                    {isMonsterFreeShippingAddToUnlock && (
                      <div className={classNames("mt-1 text-gray text-xs")}>
                        <h4
                          className={classNames(
                            "font-semibold flex items-center text-orange-500 leading-none"
                          )}
                        >
                          <Icon
                            icon="exclamation-square"
                            className="mr-1"
                            size="lg"
                          />
                          Out of date
                        </h4>
                        <p className={classNames("text-gray-600")}>
                          This add to unlock version is out of date. Please make
                          new campaign.
                          {/* <a
														className={classNames(
															"ml-2 underline cursor-pointer font-semibold"
														)}
														href="https://monsterapps.crisp.help/en/article/draft-checkout-removed-16th-may-update-de3y6j/"
														target="_blank"
													>
														Learn More
													</a> */}
                        </p>
                      </div>
                    )}
                  </div>
                );
              }
            },
            // { title: 'Name' },
            {
              title: "Type",
              value: (campaign) => {
                switch (campaign.settings.type) {
                  case "bundles":
                    return (
                      <div className={classNames("flex items-center")}>
                        <span className={classNames("mr-1 primary-icon")}>
                          <Icon icon="bars" />
                        </span>
                        <span className={classNames("hidden-sm")}>
                          Buy More Save More
                        </span>
                      </div>
                    );
                  case "add_to_unlock":
                    return (
                      <div className={classNames("flex items-center")}>
                        <span className={classNames("mr-1 primary-icon")}>
                          <Icon icon="unlock" />
                        </span>
                        <span className={classNames("hidden-sm")}>
                          Add To Unlock
                        </span>
                      </div>
                    );
                  case "one_check_up_sell":
                    return (
                      <div className={classNames("flex items-center")}>
                        <span className={classNames("mr-1 primary-icon")}>
                          <Icon icon={BOX_CHECK_ICON} />
                        </span>
                        <span className={classNames("hidden-sm")}>
                          One Check Upsell
                        </span>
                      </div>
                    );
                  default:
                    return null;
                }
              }
            },
            {
              title: "Campaign Trigger",
              value: (campaign) =>
                CAMPAIGN_TARGETS.find(
                  ({ value }) => value === campaign.target.type
                ).label
            },
            // { title: "Created At", value: "createdAt" },
            // { title: "Updated At", value: "updatedAt" },
            {
              title: "Upsells #",
              value: (campaign) =>
                analytics && analytics[campaign.id] ? (
                  numberFormat(analytics[campaign.id].UpsellsGenerated)
                ) : (
                  <Spinner size={3} />
                )
            },
            {
              title: "Revenue",
              value: (campaign) => {
                if (!analytics || !analytics[campaign.id])
                  return <Spinner size={3} />;
                const data = analytics[campaign.id];
                const revenue = data?.upsellsTotalAmount || 0;

                // if (campaign.settings.type !== "add_to_unlock")
                return (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: formatMoney(revenue)
                    }}
                  />
                );

                // const fbt_sub_total = data?.fbt?.subtotal_sum || 0;
                // const fbt_upsells_generated = data?.fbt?.UpsellsGenerated || 0;
                // return (
                //   <Popover
                //     isOpen={popovers[campaign.id] || false}
                //     // positions={["center", "center"]}
                //     padding={10}
                //     reposition={false}
                //     onClickOutside={() => hidePopOver(campaign.id)}
                //     content={() => (
                //       <div className="campaigns-popover">
                //         <h2>FBT Module</h2>
                //         <div className="flex-container">
                //           <div>
                //             <h4>Products Added</h4>
                //             <p>{fbt_upsells_generated}</p>
                //           </div>
                //           <div>
                //             <h4>Revenue Added</h4>
                //             <p
                //               dangerouslySetInnerHTML={{
                //                 __html: formatMoney(fbt_sub_total)
                //               }}
                //             />
                //           </div>
                //         </div>
                //       </div>
                //     )}
                //   >
                //     <span
                //       className="campaigns-popover-trigger"
                //       onMouseEnter={() => showPopOver(campaign.id)}
                //       onMouseLeave={() => hidePopOver(campaign.id)}
                //     >
                //       <span
                //         dangerouslySetInnerHTML={{
                //           __html: formatMoney(revenue)
                //         }}
                //       />{" "}
                //       <Icon
                //         icon="info-circle"
                //         className="campaigns-popover-info"
                //         size="sm"
                //       />
                //     </span>
                //   </Popover>
                // );
              }
            },

            { title: "Actions" }
          ]}
          actions={[
            {
              name: "Preview",
              icon: (campaign) =>
                isBeingPreviewed(campaign) ? "eye-slash" : "eye",
              color: (campaign) =>
                isBeingPreviewed(campaign) ? "primary" : "secondary",
              method: (campaign) => previewCampaign(campaign)
            },
            {
              name: "Duplicate",
              icon: "clone",
              color: "success",
              method: ({ id }) => duplicate(id),
              disabled: (campaign) => {
                const {
                  settings: { type, add_to_unlock }
                } = campaign;
                const isMonsterFreeShippingAddToUnlock =
                  type === "add_to_unlock" &&
                  add_to_unlock?.goals?.length === 1 &&
                  add_to_unlock?.goals[0].reward_type === "free_shipping" &&
                  add_to_unlock?.goals[0].free_shipping.manual === false;
                return isMonsterFreeShippingAddToUnlock;
              }
            },
            {
              name: "Edit",
              icon: "pencil-alt",
              color: "warning",
              method: ({ id }) => edit(id),
              disabled: (campaign) => {
                const {
                  settings: { type, add_to_unlock }
                } = campaign;
                const isMonsterFreeShippingAddToUnlock =
                  type === "add_to_unlock" &&
                  add_to_unlock?.goals?.length === 1 &&
                  add_to_unlock?.goals[0].reward_type === "free_shipping" &&
                  add_to_unlock?.goals[0].free_shipping.manual === false;
                return isMonsterFreeShippingAddToUnlock;
              }
            },
            {
              name: "Remove",
              icon: "trash",
              color: "danger",
              method: ({ id }) => confirmDelete(id)
            }
          ]}
          items={[...(data ? data.campaigns.list : [])]}
          emptyState={{
            action: {
              text: "New Campaign",
              url: "/campaigns/create"
            },
            text: "You don't have any campaigns, Create you first campaign."
          }}
        />
        {data?.campaigns?.nextToken && (
          <div className={classNames("p-2 text-center")}>
            <Button type="link-info" text="Load More" onClick={callLoadMore} />
          </div>
        )}
      </Page>
      <Modal
        title="Deleting a campaign"
        message="Are you sure you want to delete this campaign"
        open={!!showConfirmDelete} //cast string id to string
        primaryAction={{
          content: "Delete",
          destructive: true,
          onAction: () => {
            //call remove mutation
            RemoveCampaignMutation({
              variables: { id: showConfirmDelete }
            });
            setShowConfirmDelete(false);
          }
        }}
        secondaryActions={[
          {
            content: "Close",
            onAction: () => setShowConfirmDelete(false)
          }
        ]}
      />
    </>
  );
};

export default List;
